var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FooterRuleCheckStatus',{attrs:{"violations":_vm.violations.length,"status":_vm.status,"disabled":_vm.violations.length === 0},on:{"click":function($event){_vm.showRuleViolationModal = true}}})
}
var staticRenderFns = []

export { render, staticRenderFns }